<ng-container *ngIf="{
  request: requestAlerts$ | async,
  requestStatus: requestIsPending$ | async,
} as resolver">
  <ng-container *ngIf="systemAlerts$ | async as systemAlerts; else noDataSkeleton">
    <calendar-picker
      id="calendar-picker"
      startView="month"
      [disabled]="resolver.requestStatus || false"
      (dateSelected)="dateSelection$.next($event);">
    </calendar-picker>
    <mat-form-field
      *ngIf="inverters$ | async as inverters"
      class="custom-mat-form-field"
      subscriptSizing="dynamic"
      id="inverter-selector">
      <mat-select
        multiple
        [placeholder]="labels.inverterHeader"
        (selectionChange)="invertersFilter$.next($event.value)">
        <mat-option *ngFor="let inverter of inverters" [value]="inverter">{{ inverter }}</mat-option>
      </mat-select>
    </mat-form-field>
    <lib-block-title
      id="alert-title"
      [title]="labels.title">
    </lib-block-title>
    <div
      *ngIf="showPowerMagicAlert$ | async"
      id="power-magic-warning"
      class="fx-row fx-justify-evenly fx-wrap fx-gap-3 text-grey-400 text-300 body-2">
      <section class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-grey-100 w-full">
        <mat-icon class="text-orange-400">
          info
        </mat-icon>
        <customer-title-content
          class="fx-g-1"
          [content]="labels.powerMagicAreNotSupported">
        </customer-title-content>
      </section>
    </div>
    <ng-container *ngIf="tableAlerts$ | async as tableAlerts">
      <section
        *ngIf="tableAlerts.data"
        id="alert-table"
        class="tw-w-full overflow-hidden border-1 radius-4 tw-border-grey-100">
        <mat-form-field
          subscriptSizing="dynamic"
          class="tw-w-full tw-pb-0 tw-mb-0">
          <mat-label>{{ labels.filter }}</mat-label>
          <input
            matInput
            (keyup)="applyFilter($event)">
        </mat-form-field>
        <table
          mat-table
          matSort
          multiTemplateDataRows
          class="customer-table"
          [dataSource]="tableAlerts">
          <ng-container matColumnDef="faultCode">
            <th
              *matHeaderCellDef
              mat-header-cell
              mat-sort-header>
              {{ labels.codeHeader }}
            </th>
            <td
              *matCellDef="let element"
              mat-cell>
              <div class="tw-flex tw-items-center tw-gap-2">
                <span
                  *ngIf="element.isCurrent"
                  class="current-indicator"
                  [ngClass]="getLevelClass('current-indicator-', element.level)"
                  [matTooltip]="labels.currentAlert">
                </span>
                <span>{{element.faultCode}}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th
              *matHeaderCellDef
              mat-header-cell>
              {{ labels.descriptionHeader }}
            </th>
            <td
              *matCellDef="let element"
              mat-cell>
              {{element.description}}
            </td>
          </ng-container>
          <ng-container matColumnDef="serial">
            <th
              *matHeaderCellDef
              mat-header-cell
              mat-sort-header>
              {{ labels.inverterHeader }}
            </th>
            <td
              *matCellDef="let element"
              mat-cell>
              {{element.serial}}
            </td>
          </ng-container>
          <ng-container matColumnDef="level">
            <th
              *matHeaderCellDef
              mat-header-cell>
              {{ labels.importanceHeader }}
            </th>
            <td
              *matCellDef="let element"
              mat-cell>
              <ng-container *ngTemplateOutlet="categoryChipTemplate; context: { level: element.level }"></ng-container>
            </td>
          </ng-container>

          <!-- expand row -->
          <ng-container matColumnDef="expandedDetail">
            <td
              *matCellDef="let element"
              [class.d-none]="(expandedElementId !== element.tableId) || !expandedElementId"
              [attr.colspan]="displayedColumns.length">
              <ng-container *ngIf="expandTemplate">
                <ng-container *ngTemplateOutlet="expandTemplate; context: { element, labels, timezone: systemAlerts.timezone }"></ng-container>
              </ng-container>
            </td>
          </ng-container>

          <tr
            *matHeaderRowDef="displayedColumns"
            mat-header-row
            [class.pointer]="expandTemplate">
          </tr>

          <tr
            *matRowDef="let row; columns: displayedColumns"
            mat-row
            [ngClass]="[
              expandTemplate ? 'pointer on-hover-bg' : '',
              expandedElementId === row.tableId ? 'expanded' : '',
              getLevelClass('alert-row--current', row.level, row.isCurrent)
            ]"
            (click)="toggleRow(row)">
          </tr>

          <tr
            *matRowDef="let row; columns: ['expandedDetail']"
            mat-row
            [ngClass]="{
              'border-b-1 border-greylight-100': expandedElementId === row.tableId,
            }">
          </tr>

          <tr
            *matNoDataRow
            class="mat-row">
            <td
              class="tw-text-center tw-font-medium tw-p-2 text-grey-400 py-10"
              [attr.colspan]="displayedColumns.length">
              {{ labels.tableNoData }}
            </td>
          </tr>
        </table>
      </section>
    </ng-container>
    <ng-container *ngIf="listAlerts$ | async as listAlerts">
      <div id="alert-list">
        <div
          *ngFor="let alertMap of listAlerts.data | keyvalue;"
          class="radius-4 overflow-hidden tw-border-grey-100 border-1">
          <div class="tw-text-grey-400 tw-bg-grey-100 tw-p-3">
            {{ alertMap.key }}
          </div>
          <div
            *ngFor="let value of alertMap.value"
            class="tw-flex tw-flex-col tw-p-2 tw-border-t tw-border-grey-100"
            [ngClass]="getLevelClass('alert-item--current', value.alert.level, value.isCurrent)">
            <div class="tw-flex tw-justify-between tw-align-middle">
              <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                <span
                  *ngIf="value.isCurrent"
                  class="current-indicator"
                  [ngClass]="getLevelClass('current-indicator-', value.alert.level)"
                  [matTooltip]="labels.currentAlert">
                </span>
                <div class="tw-font-bold tw-text-grey-400">
                  {{ value.alert.faultCode }}
                </div>
              </div>
              <ng-container *ngTemplateOutlet="categoryChipTemplate; context: { level: value.alert.level }"></ng-container>
            </div>
            <div class="tw-text-grey-400">
              {{ value.alert.description }}
            </div>
          </div>
        </div>
        <div
          *ngIf="listAlerts.noData"
          class="tw-text-center tw-font-medium text-grey-400 tw-p-2 py-10">
          {{ labels.tableNoData }}
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noDataSkeleton>
    <ion-skeleton-text
      id="alert-title"
      class="w-50 h-16"
      [animated]="true">
    </ion-skeleton-text>
    <ion-skeleton-text
      id="alert-table"
      class="h-100 w-full fx-center"
      [animated]="true">
    </ion-skeleton-text>
    <ion-skeleton-text
      id="calendar-picker"
      class="w-90 h-16"
      [animated]="true">
    </ion-skeleton-text>
  </ng-template>

  <ng-template
    #categoryChipTemplate
    let-level="level">
    <mat-chip
      class="tw-text-white"
      [ngClass]="getLevelClass('chip', level)">
      {{ level | apply : convertLevelToLabel }}
    </mat-chip>
  </ng-template>
</ng-container>
